export default __webpack_public_path__ + "assets/icons/hk.04f94db5.svg";